import {showDeleteDialogAlert} from "@/utils/DialogAlertHelper"
import {showErrorSnackBar, showInfoSnackBar, showSuccessSnackBar} from '@/utils/SnackBartHelper';
import ContractsTemplatesService from "@/services/server/ContractsTemplatesService";
import ContractCustomAnchorsService from "@/services/server/ContractCustomAnchorsService";
import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import AutomateContractStorage from '@/services/storage/AutomateContractStorage';
import cloneDeep from 'lodash/cloneDeep';
import mammoth from 'mammoth';

export default {
    name: "ContractsTemplates",

    components: {},
    data: () => ({
        searchText: '',
        isLoadingButtonAddCustomAnchor: false,
        loadingAnchors: {},
        searchTextAnchors: '',
        isLoading: false,
        processingModal: false,
        headers: [
            {text: "Template", value: "templateName", width: '500px'},
            {text: "Arquivo", value: "fileName"},
            {text: "Criado em", value: 'createdAt'},
            {text: "Status", value: "isActive"},
            {text: "Ações", value: "actions"},
        ],
        validForm: false,
        contractDialog: false,
        showFileDialog: false,
        contracts: [],
        customAnchors: [],
        templateContractFile: null,
        fileUrl: null,
        fileContent: null,
        contract: {
            id_doc: null,
            templateName: "",
            filePath: null,
            fileName: "",
            isActive: true,
        },
        suggestedAnchors: [
            {
                name: "Cliente",
                anchors: ["NOME_CLIENTE", "DOCUMENTO_CLIENTE", "EMAIL_CLIENTE", "TELEFONE_CLIENTE", "MATRICULA_CLIENTE", "LOGRADOURO_CLIENTE", "COMPLEMENTO_CLIENTE",
                    "CIDADE_CLIENTE", "BAIRRO_CLIENTE", "ESTADO_CLIENTE", "NUMERO_CASA_CLIENTE", "CEP_CLIENTE", "DOCUMENTO_RESPONSAVEL", "EMAIL_RESPONSAVEL",
                    "NOME_RESPONSAVEL", "TELEFONE_RESPONSAVEL", "QUALIFICACAO_RESPONSAVEL","RG_RESPONSAVEL", "TOTAL_UNIDADES", "TOTAL_DE_ANDARES", "UNIDADES_POR_ANDAR",
                    "NUMERO_TORRES", "BANHEIROS_POR_UNIDADE", "TAXA_MINIMA","EMAIL_COBRANCA_CLIENTE","TELEFONE_COBRANCA_CLIENTE"]
            },
            {
                name: "Local",
                anchors: ["NOME_PROJETO"]
            },
            {
                name: "Franqueado",
                anchors: ["CPF_RESPONSAVEL","RAZAO_SOCIAL","NOME_FRANQUEADO", "EMAIL_FRANQUEADO", "TELEFONE_FRANQUEADO", "DOCUMENTO_FRANQUEADO", "LOGRADOURO_FRANQUEADO",
                    "COMPLEMENTO_FRANQUEADO", "CIDADE_FRANQUEADO", "BAIRRO_FRANQUEADO", "ESTADO_FRANQUEADO", "NUMERO_CASA_FRANQUEADO", "CEP_FRANQUEADO"],
            },
            {
                name: "Proposta",
                anchors: ["VALOR_TOTAL_PROPOSTA", "MEDIA_REF_AGUA_M3", "MEDIA_REF_ESGOTO_M3", "MEDIA_REF_RS", "PERCENTUAL_PAGAMENTO",
                    "DESCONTO_PROPOSTA", "TIPO_DESCONTO_PROPOSTA", "TIPO_PROPOSTA", "ECONOMIA_CLIENTE", "PAYBACK_MIN", "PAYBACK_MAX", "DURACAO_CONTRATO"]
            },
            {
                name: "Geral",
                anchors: ["MES_EXTENSO", "DIA", "ANO"]
            }
        ],
        newCustomAnchor: '',

    }),
    computed: {
        ruleRequired() {
            return Rules.required();
        },
        searchedContracts() {
            return this.contracts.filter(contract => {
                const templateName = contract.templateName || "";
                return templateName.toLowerCase().includes(this.searchText.toLowerCase());
            });
        },
        filteredSuggestedAnchors() {
            if (!this.searchTextAnchors.trim()) {
                return this.suggestedAnchors; // Retorna todas as categorias se o campo de busca estiver vazio
            }

            const searchText = this.searchTextAnchors.toLowerCase();

            // Filtra as categorias e âncoras com base no texto digitado
            return this.suggestedAnchors
                .map(category => {
                    const filteredAnchors = category.anchors.filter(anchor =>
                        anchor.toLowerCase().includes(searchText)
                    );

                    if (filteredAnchors.length > 0) {
                        return {
                            name: category.name,
                            anchors: filteredAnchors
                        };
                    }
                    return null;
                })
                .filter(category => category !== null); // Remove categorias vazias
        },

        filteredCustomAnchors() {
            if (!this.searchTextAnchors.trim()) {
                return this.customAnchors; // Retorna todas as âncoras personalizadas se o campo de busca estiver vazio
            }

            const searchText = this.searchTextAnchors.toLowerCase();

            return this.customAnchors.filter(anchor =>
                anchor.anchorName.toLowerCase().includes(searchText)
            );
        },
        defineModalTitle() {
            if (this.contract.id_doc) {
                return "Editar Template de Contrato"
            } else {
                return "Criar Template de Contrato"
            }
        }
    },
    methods: {
        formattedDate(date) {
            if (date === undefined) return

            if (date['_seconds'] !== undefined && date['_nanoseconds'] !== undefined) {
                return Utils.formatDateDayJs(date['_seconds'] * 1000 + date['_nanoseconds'] / 1e6, 'DD/MM/YYYY [às] HH:mm');
            } else {
                return Utils.formatDateDayJs(new Date(date), 'DD/MM/YYYY [às] HH:mm');
            }
        },
        async handleImageSave() {
            if (this.contract.filePath) {
                await AutomateContractStorage.deleteImg(this.contract.filePath);
            }
            this.contract.filePath = await AutomateContractStorage.uploadFile(this.templateContractFile);
        },
        async saveContract() {
            if (!this.$refs.contractTemplates.validate()) {
              showErrorSnackBar("Existem pêndencias no formulário!")
              return;
            }

            this.isLoading = true;
            this.processingModal = true;

            try {
                await this.handleImageSave();

                this.contract.fileName = this.templateContractFile.name

                if (this.contract.id_doc) {
                    this.contract.updatedAt = new Date()

                    await ContractsTemplatesService.saveTemplate(this.contract).then(r => {
                        showSuccessSnackBar("Template atualizado com sucesso!");

                        this.contracts = this.contracts.map(contract =>
                            contract.id_doc === this.contract.id_doc ? this.contract : contract
                        );

                    }).catch(e => {
                        showErrorSnackBar("Erro ao atualizar o template.");
                        console.error("Erro ao atualizar o template.", e);
                    });
                } else {
                    this.contract.createdAt = new Date()

                    await ContractsTemplatesService.saveTemplate(this.contract).then(r => {
                        showSuccessSnackBar("Template criado com sucesso!");
                        this.contract.id_doc = r.data.data;
                        this.contracts.unshift(this.contract);

                    }).catch(e => {
                        showErrorSnackBar("Erro ao atualizar o template.");
                        console.error("Erro ao atualizar o template.", e);
                    });
                }
                await this.getCustomAnchors();
            } catch (error) {
                console.error("Erro ao salvar o template:", error);
                showErrorSnackBar("Erro ao salvar o template.");
            } finally {
                this.isLoading = false;
                this.processingModal = false;
                this.closeContractDialog();
            }
        },
        async editContract(contract) {
            this.isLoading = true;
            this.contract = cloneDeep(contract);
            if (this.contract.filePath) {
                const blob = await AutomateContractStorage.downloadImg(this.contract.filePath);
                this.templateContractFile = new File([blob], this.contract.fileName || 'documento.docx', {type: blob.type})
            }
            this.openContractDialog();
            this.isLoading = false;
        },
        async handleDownload(contract) {
            const url = URL.createObjectURL(this.fileUrl);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', contract.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.contract = {
                id_doc: null,
                templateName: "",
                filePath: "",
                fileName: "",
                isActive: true,
            }
        },
        async handleViewFile(contract) {
            this.isLoading = true
            this.contract = cloneDeep(contract);
            const filePath = contract.filePath;
            this.fileUrl = await AutomateContractStorage.downloadImg(filePath);

            if (!this.fileUrl) {
                console.error("O Blob retornado está vazio ou houve um erro no download.");
                return;
            }

            const arrayBuffer = await new Response(this.fileUrl).arrayBuffer();

            try {
                const { value: html } = await mammoth.convertToHtml({ arrayBuffer });
                this.fileContent = html;

                this.isLoading = false
                this.showFileDialog = true;
            } catch (error) {
                console.error("Erro ao converter o arquivo:", error);
            }
        },
        async handleClickDeleteContract(contract) {
            showDeleteDialogAlert("Deseja deletar definitivamente esse template de contrato?", () => this.deleteContract(contract));
        },
        async deleteContract(contract) {
            const response = await ContractsTemplatesService.deleteTemplateContract(contract.id_doc);

            if (response.data.data) {
                this.contracts = this.contracts.filter(item => item.id_doc !== contract.id_doc);
                showSuccessSnackBar("Contrato deletado com sucesso!")
            }
        },
        openContractDialog() {
            this.contractDialog = true;
        },
        closeContractDialog() {
            this.contractDialog = false;
            this.templateContractFile = null
            this.contract = {
              id_doc: null,
              templateName: "",
              filePath: "",
              fileName: "",
              isActive: true,
            }
        },
        formatAnchor(anchor) {
            return `{{${anchor}}}`;
        },
        copyAnchorToClipboard(anchor) {
            navigator.clipboard
                .writeText(anchor)
                .then(() => {
                    showInfoSnackBar(`Âncora ${anchor} copiada para a área de transferência!`);
                })
                .catch((err) => {
                    console.error("Erro ao copiar para a área de transferência:", err);
                    showErrorSnackBar("Erro ao copiar a âncora.");
                });
        },
        async addCustomAnchor() {
            this.isLoadingButtonAddCustomAnchor = true;
            const trimmedAnchor = this.newCustomAnchor.trim();

            if (trimmedAnchor) {
                const formattedAnchor = trimmedAnchor.toUpperCase().replace(/\s+/g, "_");
                const formattedAnchorToSave = formattedAnchor.replace(/{{|}}/g, "");
                if (!this.customAnchors.some(anchor => anchor.anchorName === formattedAnchor) && !this.suggestedAnchors.some(anchor => anchor.anchors.includes(formattedAnchor))) {
                    const response = await ContractCustomAnchorsService.createCustomAnchor(formattedAnchorToSave);
                    if (response.data.data) {
                        this.customAnchors.push({id_doc: response.data.data, anchorName: formattedAnchor})
                        this.newCustomAnchor = "";
                        showSuccessSnackBar("Âncora personalizada adicionada com sucesso!");
                    }
                } else {
                    showErrorSnackBar("Essa âncora já foi adicionada!");
                }
            } else {
                showErrorSnackBar("O campo de âncora não pode estar vazio!");
            }
            this.isLoadingButtonAddCustomAnchor = false;
        },
        async deleteAnchor(idDocAnchor) {
            this.$set(this.loadingAnchors, idDocAnchor, true);

            const response = await ContractCustomAnchorsService.deleteCustomAnchor(idDocAnchor);
            if (response.data.data) {
                this.customAnchors = this.customAnchors.filter((item) => item.id_doc !== idDocAnchor);
                showSuccessSnackBar("Âncora removida com sucesso!");
            }
            this.$set(this.loadingAnchors, idDocAnchor, false);
        },
        async getContracts() {
            const response = await ContractsTemplatesService.getAll();
            this.contracts = cloneDeep(response.data.data);
        },
        async getCustomAnchors() {
            const response = await ContractCustomAnchorsService.getAllCustomsAnchors();
            this.customAnchors = response.data.data
        }
    },
    async created() {
        this.isLoading = true;
        await this.getContracts();
        await this.getCustomAnchors();
        this.isLoading = false;
    },
}
